export const userRoles = {
  ADMIN: 'admin',
  SUPER_USER: 'super_user',
  MODERATOR: 'moderator',
  OPERATOR: 'operator',
};
